<template>
    <div class="main-header clearfix">
        <span>课堂内外数字资源中心</span>
        <the-right-content class="float-right"></the-right-content>
    </div>
</template>

<script>
import TheRightContent from '@layouts/main/components/TheRightContent';
export default {
    name: 'TheHeader',
    components: { TheRightContent }
};
</script>

<style lang="scss" scoped>
.main-header {
    height: 60px;
    line-height: 60px;
    overflow: hidden;
    font-size: 24px;
    font-weight: bold;
    color: #656565;
}
</style>
